class Hero extends Component {
    constructor(el) {
        super(el);
        this.swiperEl = this.$find('[data-hero-swiper]');
        this.swiper = null;
        this.swiperEl && this.constructSwiper();
    }

    constructSwiper() {
        this.swiper = new Swiper(this.swiperEl, {
            watchOverflow: true,
            slidesPerView: 1,
            pagination: {
                el: '[data-hero-pagination]',
                clickable: true
            },
            navigation: {
                nextEl: '[data-hero-next]',
                prevEl: '[data-hero-prev]',
            },
            autoplay: {
                delay: 10000,
            },
            grabCursor: true,
        });
    }
}
